<template>
  <div class="p-4 max-w-xl mx-auto" v-if="!isLoading">
    <div @click="$router.back()" class="w-10 h-10 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300 cursor-pointer shadow-md transition">
      <BackSvg />
    </div>

    <div class="flex flex-col justify-center items-center">
      <h2 class="text-lg text-zinc-700 text-center font-semibold">About IMF Telemed</h2>
    </div>
    <div>
      <div class="flex flex-col justify-center items-center">
        <img :src="require('@/assets/logo-primary.png')" alt="" class="w-56 h-auto" />
        <div class="text-xs text-center text-zinc-500 relative bottom-4">
          {{ appVersion }}
        </div>
      </div>

      <div class="space-y-4 text-gray-700 text-base leading-7 text-left">
        <p>
          Interfaced Medical Facilities (IMF) is a comprehensive healthcare service provider committed to delivering accessible, efficient, and patient-centered medical solutions
          through advanced teleconsultation technology. We bridge the gap between patients and healthcare professionals by offering a platform that allows individuals to receive
          medical attention anytime, anywhere—without the need for physical clinic visits.
        </p>

        <p>
          IMF was established with the mission of making healthcare more convenient and responsive to the needs of modern-day patients. Through our digital telecons platform, we
          ensure that people can consult licensed doctors, receive medical guidance, and gain access to health services from the comfort of their homes or workplaces. By
          integrating secure communication systems, user-friendly features, and reliable support, we aim to create a seamless healthcare experience for all.
        </p>
      </div>
    </div>
  </div>

  <div v-else class="flex items-center justify-center h-48">
    <svg class="w-10 h-10 animate-spin text-orange-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
    </svg>
  </div>
</template>

<script>
import { ref } from "vue";
import BackSvg from "@/components/svgs/BackSvg.vue";
import systemVersion from "@/utils/version";

export default {
  name: "UpdateProfile",
  components: { BackSvg },
  setup() {
    const isLoading = ref(false);
    const isAlert = ref(false);
    const loading = ref(false);
    const { appVersion } = systemVersion();

    return {
      isLoading,
      isAlert,
      loading,
      appVersion,
    };
  },
};
</script>
